module.exports = __webpack_public_path__ + "h5assets/img/meixin.da65dd2.png";